import * as React from 'react';

// Assets
import '../Assets/LandingPage.sass';

// Components
import Navbar from 'Screens/Layout/Common/Components/Navbar';

// Components
export default class LandingPage extends React.Component<{}, {}> {
    public render() {
        return window.location.href = `/accounts/landing`;
    }
}
